import { render, staticRenderFns } from "./CountryCenters.vue?vue&type=template&id=55c6dfe4"
import script from "./countryCenters.ts?vue&type=script&lang=js&external"
export * from "./countryCenters.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports